import { switchMap, take } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { dataAccessEnvironment } from '../../models/data-access-environment';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { postJwt } from '../authws/post-jwt';
import { fleetEnvironment } from './fleet-environment';
import { routeModifierSchema } from './schemas/route-modifier.schema';

export function getAvoidFavorSetsId(setId: number) {
  return postJwt({ authenticationToken: dataAccessEnvironment.authToken }).pipe(
    take(1),
    switchMap((jwt) => {
      return fromFetch(
        new Request(`${fleetEnvironment.avoidFavorSetsUrl}/${setId}`, {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            Authorization: `bearer ${jwt.access_token}`,
          },
        })
      ).pipe(selectData(routeModifierSchema));
    })
  );
}
